import { TooltipContextProvider } from '@stormwater-software/lib-ui';
import _, { findIndex } from 'lodash';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ProjectPermissionState } from '../../contexts/ProjectPermissionContext';
import RolesContext from '../../contexts/RolesContext';
import withProjectPermissionContext from '../../hoc/withProjectPermissionContext';
import uploadApi from '../../utils/api/upload';
import ConfirmationModal from '../Shared/ConfirmationModal/ConfirmationModal';
import ConvertDocModal from '../Shared/ConvertDocument/ConvertDocModal';
import FileRenameModal from '../Shared/FileRow/FileRenameModal';
import FileCardList from '../Shared/FileRow/List';
import WebViewerModal from '../Shared/PDFEditor/WebViewerModal';
import SuccessModal from '../Shared/SuccessModal/SuccessModal';
import clientApi from '../../utils/api/client';
import { ProjectContext } from '../../contexts/ProjectContext';
import { getProjectConfigHelpers } from './Forms/projectFormSchema';
import { toast } from "react-toastify";
import AppContext from '../../contexts/AppContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import projectApi from '../../utils/api/project';
import TrackPermitModal from '../Shared/FileRow/TrackPermitModal';
import permitApi from '../../utils/api/permit';

const allowedTypes = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'application/pdf',
];

export interface IProjectDocumentsProps {
  documentTypes: Array<any>;
  regulations: Array<any>;
  onDocumentDelete: (guid: string) => void;
  onDocumentUpload: (search?: any) => void;
  projectId: number;
  onMove: (e: MouseEvent, name: string) => void;
  onDrop: (e: MouseEvent, name: string) => void;
  shouldRenderRegulations: () => void;
  projectPermissionContext: ProjectPermissionState;
}

const ProjectDocuments: React.FC<IProjectDocumentsProps> = ({
  documentTypes,
  onDocumentDelete,
  onDocumentUpload,
  projectId,
  onMove,
  onDrop,
  shouldRenderRegulations,
  projectPermissionContext,
}) => {
  const rolesContext = useContext(RolesContext);
  const [confirm, setConfirm] = useState<boolean>(false);
  const [docTypeName, setDocTypeName] = useState<string>('');
  const [showEditor, setShowEditor] = useState<boolean>(false);
  const [showDownload, setShowDownload] = useState<boolean>(false);
  const [rename, setRename] = useState<boolean>(false);
  const [showTrackPermitModal, setShowTrackPermitModal] = useState<boolean>(false);
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
  const [filename, setFilename] = useState<string>('');
  const [docGuid, setDocGuid] = useState<string>('');
  const [docId, setDocId] = useState<number>(-1);
  const [errorText, setErrorText] = useState<string>('');
  const [showConvert, setShowConvert] = useState<boolean>(false);
  const [convertQueue, setConvertQueue] = useState<Array<any>>([]);
  const [isWaiting, setIsWaiting] = useState<boolean>(false);
  const [docType, setDocType] = useState<any>({});
  const projectContext = useContext(ProjectContext)
  const { hasDocEditing } = getProjectConfigHelpers(
    (projectContext.project?.project_config || 'full') as any,
  )
  const [docTypes, setDocTypes] = useState<Array<any>>([])
  const [isAdmin, setIsAdmin] = useState(false)
  const appContext = useContext(AppContext)
  const [shouldReloadDocumentsPage, setShouldReloadDocumentsPage] = useState(false)
  const [selectedSubDocType, setSelectedSubDocType] = useState<any>()
  const searchRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    projectContext.loadDocs(projectId, searchRef.current?.value || "")
  }, [shouldReloadDocumentsPage])

  useEffect(() => {
    setIsAdmin(appContext.get("user").roleName === 'Admin')
  }, [])
  const clientId = projectContext.project && projectContext.project.client_id

  const docTypeRearrange = (data: any) => {
    const newDoc: any = []
    const Doc = data
      .sort((a: any, b: any) => a.order - b.order)
      .map((ele: any) => ele.name)

    Doc.map((newdoc: any) => {

      for (const keys in data) {
        if (data[keys].name === "Active Site Maps" && newdoc === "Active Site Maps") {
          // dont push "Active Site Maps" to newDoc
        } else if (data[keys].name === newdoc) {
          newDoc.push(data[keys])
        }
      }
    })

    for (const keys in data) {
      if (!Doc.includes(data[keys].name)) {
        newDoc.push(data[keys])
      }
    }

    if (!searchRef.current || searchRef.current?.value === '') setDocTypes(newDoc);
    else {
      const filteredDocTypes = newDoc.filter((docType: any) => {
        const subFolderList = docType.documents
          .filter((doc: any) => doc.sub_doc_type)
          .map((doc: any) => doc.sub_doc_type.id);

        const docsNotInSubfolder = docType.documents
          .filter((doc: any) => doc.ProjectUploadModel)
          .filter((doc: any) => {
            return (
              !doc.ProjectUploadModel.project_sub_doc_type_id ||
              subFolderList.includes(
                doc.ProjectUploadModel.project_sub_doc_type_id,
              )
            );
          });
        return docType.documents.length > 0 && (docsNotInSubfolder.length > 0 || subFolderList.length > 0);
      });
      setDocTypes(filteredDocTypes);
    }  
  }

  useEffect(() => {

    if (!clientId || !projectContext.project?.doc_type_group_id) return;

    // clientApi.getClientsDocTypes.forProjects(clientId)
    clientApi.documentGroups.getDocTypeGroupItems(clientId,projectContext.project.doc_type_group_id)
      .then((data) => {

         const clientDocTypes= data.map((folder: any) => {
            return {
              doctype_id: folder.doc_type_id,
              name: folder.doc_type?.name || folder.name,
            };
          });
        const combinedArray: any = []
        

        documentTypes.filter((docType:any)=>docType.name!=='Fixed Details').forEach(ele => {
          clientDocTypes.forEach((e: any) => {
            if (e.doctype_id === ele.id) {
              combinedArray.push({ ...ele, order: e.order })
            }
          })
        })

        return combinedArray
      })
      .then(data => docTypeRearrange(data))
    if (clientId)
      clientApi.index([clientId]).then((c: any) => {
        projectContext.setDocumentDate(c[0].document_date);
      });
  }, [projectContext])

  const hideEditor = () => {
    setShowEditor(false);
    setShowDownload(false)
    setDocGuid('');
    setDocId(-1);
  };

  const showRename = async (document: any, documentType: any) => {
    setRename(true);
    setDocGuid(document.GUID);
    setDocId(document.id);
    setFilename(document.name);
    setDocType(documentType);
  };

  const hideRename = () => {
    setDocGuid('');
    setDocId(-1);
    setFilename('');
    setRename(false);
    setDocType({});
  };

  const handleRename = async (newName: any) => {
    await uploadApi.rename(docGuid, newName);
    selectedSubDocType && await reloadSelectedSubDocTypeData()
    hideRename();

    return onDocumentUpload(searchRef.current?.value || "")
  };

  const hideConfirm = () => {
    setConfirm(false);

    return false;
  };

  const onConfirmOverwrite = () => {
    hideConfirm();

    return true;
  };

  const handleUpload = (
    newFile: any,
    projectDocId: number,
  ) => {

    if (selectedSubDocType) {
      return uploadApi.project
        .create(newFile.id, projectId, projectDocId, selectedSubDocType.id)
        .then(() => {
          return onDocumentUpload(searchRef.current?.value || "")
        })
        .catch((err) => {
          setErrorText(
            err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : 'An error has occurred',
          );
          setShowErrorModal(true);
        });
    }

    return uploadApi.project
      .create(newFile.id, projectId, projectDocId)
      .then(() => {
        return onDocumentUpload(searchRef.current?.value || "")
      })
      .catch((err) => {
        setErrorText(
          err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'An error has occurred',
        );
        setShowErrorModal(true);
      });
  }

  const handleDelete = async (doc: any) => {
    permitApi.deleteByFileId(doc.ProjectUploadModel.id)
    uploadApi.project
      .destroy(projectId, doc.id)
      .then(async () => {
        selectedSubDocType && await reloadSelectedSubDocTypeData()
        onDocumentDelete(doc.GUID);
        projectContext.loadDocs(projectId, searchRef.current?.value || "")
      })
      .catch((err) => {
        setErrorText(
          err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'An error has occurred',
        );
        setShowErrorModal(true);
      });
  }

  const handleDownload = (doc: any) => {
    toast("Download has started")
    setShowDownload(true)
    setDocGuid(doc.GUID);
    setDocId(doc.id);
    setFilename(doc.name);
  }

  const handleReplace = async (
    newFile: any,
    projectDocId: number,
  ) => {
    return uploadApi.project
      .create(newFile.id, projectId, projectDocId)
      .then(() => {
        setIsWaiting(false)

        return onDocumentUpload(searchRef.current?.value || "")
      })
      .catch((err) => {
        setErrorText(
          err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'An error has occurred',
        );
        setShowErrorModal(true);
      });
  };

  // handle a converted file
  const handleConverted = () => {
    return onDocumentUpload(searchRef.current?.value || "")
  };

  const handleEdit = (document: any) => {
    setDocTypeName(document.docTypeName)
    setShowEditor(true);
    setDocGuid(document.GUID);
    setDocId(document.id);
    setFilename(document.name);
  };

  const onEdit = () => {
    onDocumentUpload(searchRef.current?.value || "")
  };

  const dequeue = (upload: any) => {
    // remove from conversion queue
    const inx = findIndex(convertQueue, {
      id: upload.id,
    });

    if (inx !== null) {
      setConvertQueue([
        ...convertQueue.slice(0, inx),
        ...convertQueue.slice(inx + 1),
      ]);
    }
  };

  const reloadSelectedSubDocTypeData = async () => {
    const updatedData = await projectApi.getDocs(projectId, null, searchRef.current?.value || "")
    const relevantDocType = updatedData.documentTypes.filter((docTypeEle: any) => docTypeEle.project_doc_type_id === selectedSubDocType.project_doc_type_id)
    const relevantSubDocType = relevantDocType[0].documents.filter((documentEle: any) => documentEle.id === selectedSubDocType.id)

    setSelectedSubDocType(relevantSubDocType[0])
  }

  const handleSearchFunc = _.debounce(() => {
    projectContext.loadDocs(projectId, searchRef.current?.value || "")
  }, 500);

  return (
    <TooltipContextProvider>
      <section className='documents'>
      {!selectedSubDocType && <input
        type='search'
        className='search-control'
        style={{
          width: '100%',
        }}
        ref={searchRef}
        placeholder='Search Documents...'
        defaultValue={searchRef.current?.value || ""}
        onChange={handleSearchFunc}
      />}
        {
          selectedSubDocType ? // to show only SELECTED SUB FOLDER
            <>
              <div
                className='all-files-button'
                onClick={() => setSelectedSubDocType("")}
              >
                <span className='all-files-button-icon'><FontAwesomeIcon icon={faArrowLeft} /></span>
                <span className='all-files-button-text'>All Files</span>
              </div>
              <input
              type='search'
              style={{
                display: 'none'
              }}
              ref={searchRef}
              defaultValue={searchRef.current?.value || ""}
            />
              <FileCardList
                key={selectedSubDocType && selectedSubDocType.sub_doc_type && selectedSubDocType.sub_doc_type.id}
                onMove={(e: any) => onMove(e, selectedSubDocType && selectedSubDocType.sub_doc_type && selectedSubDocType.sub_doc_type.name)}
                onDrop={(e: any) => onDrop(e, selectedSubDocType && selectedSubDocType.sub_doc_type && selectedSubDocType.sub_doc_type.name)}
                groupName={selectedSubDocType && selectedSubDocType.sub_doc_type && selectedSubDocType.sub_doc_type.name}
                actualGroupName={docTypes.find(docType => docType.documents.some((doc: any) =>
                  doc.id === selectedSubDocType.id
                )
                ).name}
                documents={
                  selectedSubDocType && [...selectedSubDocType.project_uploads
                    .sort((a: any, b: any) => a.order - b.order)
                    .map((ele: any) => {
                      return {
                        ...ele.upload,
                        ProjectUploadModel: ele
                      }
                    })
                  ]}
                isWaiting={isWaiting}
                canDownload={rolesContext.userHasPermission('all', 'Download')}
                {...projectPermissionContext.getDocumentProps(docType.name)}
                handleEdit={(doc: any) => handleEdit(doc)}
                handleRename={async (doc: any) => {
                  await showRename(doc, docType)
                  await reloadSelectedSubDocTypeData()
                }}
                handleTrackPermit={(doc: any) => {
                  setShowTrackPermitModal(true)
                  setDocId(doc.id)
                }}
                handleReplace={async (newDoc: any, doc: any) => {
                  let response = await uploadApi.create(newDoc);

                  await handleReplace(
                    response,
                    selectedSubDocType && selectedSubDocType.project_doc_type_id,
                  );

                  let payload = {
                    newDoc: {
                      ...response,
                      project_doc_type_id:
                        selectedSubDocType &&
                        selectedSubDocType.project_doc_type_id,
                      project_id: projectId,
                    },
                    oldDoc: doc,
                  };

                  await permitApi.deleteByFileId(doc.ProjectUploadModel.id)
                  await uploadApi.project.replaceDocData(projectId, payload)
                  await reloadSelectedSubDocTypeData();
                  projectContext.loadDocs(projectId, searchRef.current?.value || "")
                }
                }
                handleDownload={(doc: any) => handleDownload(doc)}
                onUpload={async (newFile: any) => {
                  await handleUpload(
                    newFile,
                    selectedSubDocType.project_doc_type_id,
                  )
                  await reloadSelectedSubDocTypeData()
                }}
                minimumImageDimensions={
                  {
                    width: 20,
                    height: 20,
                  }
                }
                handleDelete={async (doc: any) => {
                  await handleDelete(doc)
                }}
                permCheck={rolesContext.userHasPermission}
                label="Project Documents"
                allowedTypes={allowedTypes}
                document_date={projectContext.document_date}
                isAdmin={isAdmin}
                isProjectDocumentsPage={true}
                docTypes={docTypes}
                setShouldReloadDocumentsPage={setShouldReloadDocumentsPage}
                documentType={selectedSubDocType}
                projectId={projectId}
                selectedSubDocType={selectedSubDocType}
                setSelectedSubDocType={setSelectedSubDocType}
                reloadSelectedSubDocTypeData={reloadSelectedSubDocTypeData}
                showAddSubFolderIcon={true}
                canManageSubfolder={rolesContext.userHasPermission('all', 'Manage Subfolders')}
              />
            </>
            :
            (docTypes.filter(e => e.name !== 'Fixed Details Project')
              .map((documentType: any) => {
                if (
                  documentType.name === 'Regulations' &&
                  shouldRenderRegulations()
                ) {
                  return (
                    <FileCardList
                      permCheck={rolesContext.userHasPermission}
                      groupName={documentType.name}
                      documents={documentType.documents.filter((e: { docTypeName: string; }) => e.docTypeName === 'Regulations')}
                      canUpload={false}
                      canDownload={rolesContext.userHasPermission('all', 'Download')}
                      canRename={false}
                      canEdit={false}
                      isWaiting={isWaiting}
                      handleDownload={(doc: any) => handleDownload(doc)}
                      handleEdit={(doc: any) => handleEdit(doc)}
                      key={documentType.id || documentType.name}
                      canDrag={false}
                      onMove={(e: any) => onMove(e, documentType.name)}
                      onDrop={(e: any) => onDrop(e, documentType.name)}
                      allowedTypes={allowedTypes}
                      isProjectDocumentsPage={true}
                      docTypes={docTypes}
                      setShouldReloadDocumentsPage={setShouldReloadDocumentsPage}
                      document_date={projectContext.document_date}
                      documentType={documentType}
                      projectId={projectId}
                      setSelectedSubDocType={setSelectedSubDocType}
                      showAddSubFolderIcon={true}
                      canManageSubfolder={rolesContext.userHasPermission('all', 'Manage Subfolders')}
                    />
                  );
                }

                return (
                  <FileCardList
                    key={documentType.id}
                    onMove={(e: any) => onMove(e, documentType.name)}
                    onDrop={(e: any) => onDrop(e, documentType.name)}
                    groupName={documentType.name}
                    documents={documentType.documents}
                    isWaiting={isWaiting}
                    canDownload={rolesContext.userHasPermission('all', 'Download')}
                    {...projectPermissionContext.getDocumentProps(docType.name)}
                    canEdit={hasDocEditing}
                    handleRename={(doc: any) => showRename(doc, docType)}
                    handleTrackPermit={(doc: any) => {
                      setShowTrackPermitModal(true)
                      setDocId(doc.id)
                    }}
                    handleEdit={(doc: any) => handleEdit(doc)}
                    handleReplace={async (newDoc: any, doc: any) => {
                      let response = await uploadApi.create(newDoc)

                      await handleReplace(
                        response,
                        documentType.project_doc_type_id,
                      )

                      let payload = {
                        newDoc: {
                          ...response,
                          project_doc_type_id: documentType.project_doc_type_id,
                          project_id: projectId
                        },
                        oldDoc: doc
                      }

                      await permitApi.deleteByFileId(doc.ProjectUploadModel.id)
                      await uploadApi.project.replaceDocData(projectId, payload)

                      projectContext.loadDocs(projectId, searchRef.current?.value || "")
                    }
                    }
                    handleDownload={(doc: any) => handleDownload(doc)}
                    onUpload={(newFile: any) =>
                      handleUpload(
                        newFile,
                        documentType.project_doc_type_id,
                      )
                    }
                    minimumImageDimensions={
                      {
                        width: 20,
                        height: 20,
                      }
                    }
                    handleDelete={(doc: any) => handleDelete(doc)}
                    permCheck={rolesContext.userHasPermission}
                    label="Project Documents"
                    allowedTypes={allowedTypes}
                    document_date={projectContext.document_date}
                    isAdmin={isAdmin}
                    isProjectDocumentsPage={true}
                    docTypes={docTypes}
                    setShouldReloadDocumentsPage={setShouldReloadDocumentsPage}
                    documentType={documentType}
                    projectId={projectId}
                    setSelectedSubDocType={setSelectedSubDocType}
                    showAddSubFolderIcon={true}
                    canManageSubfolder={rolesContext.userHasPermission('all', 'Manage Subfolders')}
                  />
                );
              }))}
          {!docTypes.length && (
            <div className='no-documents'>
              <p>No documents found.</p>
            </div>
          )}
      </section>

      {/* load modals into DOM */}
      <ConfirmationModal
        show={confirm}
        handleClose={hideConfirm}
        handleConfirm={onConfirmOverwrite}
        title='Are you sure you want to delete this document?'
        subTitle='This can not be undone.'
        buttonText='Delete Document'
      />

      <WebViewerModal
        show={showEditor}
        onClose={hideEditor}
        onSave={() => onEdit()}
        guid={docGuid}
        id={docId}
        uploadId={docId}
        filename={filename}
        disableDownload={!rolesContext.userHasPermission("all", "Download")}
        canEdit={hasDocEditing && docTypeName !== "Regulations" && rolesContext.userHasPermission("update", "Project Documents")}
      />

      <WebViewerModal
        show={showDownload}
        onClose={hideEditor}
        onSave={() => onEdit()}
        guid={docGuid}
        id={docId}
        uploadId={docId}
        canDownload={true}
        filename={filename}
        canEdit={hasDocEditing && rolesContext.userHasPermission("update", "Project Documents")}
      />

      {/* invalid file type || DB error */}
      <SuccessModal
        show={showErrorModal}
        handleClose={() => setShowErrorModal(false)}
        handleSubmit={() => setShowErrorModal(false)}
        submitBtnText='OK'
        message={errorText}
        title='Error'
        isAlert
      />

      {showConvert && (
        <ConvertDocModal
          docs={convertQueue}
          handleClose={() => {
            setShowConvert(false);
            setConvertQueue([]);
          }}
          handleConverted={handleConverted}
          dequeue={dequeue}
        />
      )}
      <FileRenameModal
        show={rename}
        file={{ guid: docGuid, name: filename }}
        onCancel={hideRename}
        onSubmit={(fileName) => handleRename(fileName)}
      />

      <TrackPermitModal
        show={showTrackPermitModal}
        onCancel={() => setShowTrackPermitModal(false)}
        onSubmit={() => {
          setShowTrackPermitModal(false);
          selectedSubDocType ? reloadSelectedSubDocTypeData() : projectContext.loadDocs(projectId, searchRef.current?.value || "")
        }}
        fileId={docId}
      />
    </TooltipContextProvider>
  );
};

export default withProjectPermissionContext(ProjectDocuments);
